import { columns } from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/membership'
export const namespace = 'membership'
export const clientRoute = '/membership'
export const dependencies = ['membershipType', 'membershipPeriod']
export const params = {
  include: 'MembershipType,MembershipPeriod',
  sort: ''
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'membershipType'
const subtitleColumn = 'membershipPeriod'
const infoColumns = ['yearJoined', 'isActive']
/* --------------------------- */

const state = {
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  titleColumn,
  subtitleColumn,
  infoColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
